export default "__VITE_ASSET__DV6jQSBe__"